// import React from "react";
// import { Box, Container, Grid, Typography } from "@mui/material";
// import AnimatedSection from "../common/AnimatedSection";
// import SectionHeading from "../common/SectionHeading";

// const NAVY = "#1B1F3B"; const CORAL = "#FF6B6B"; const YELLOW = "#FFD93D"; const TEAL = "#06D6A0"; const PURPLE = "#845EF7"; const ORANGE = "#FF9F1C";

// const ICONS = ["👩‍🏫", "📖", "🧠", "🤝"];
// const COLORS = [TEAL, CORAL, YELLOW, PURPLE];

// const FacultySection = ({ highlights }) => (
//   <AnimatedSection sx={{ backgroundColor: PURPLE, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
//     <Box sx={{ position:"absolute", top:-50, right:-50, width:200, height:200, borderRadius:"50%", border:`3px solid rgba(255,255,255,0.15)`, backgroundColor:"rgba(255,255,255,0.05)" }} />
//     <Box sx={{ position:"absolute", bottom:-60, left:-60, width:240, height:240, borderRadius:"50%", border:`3px solid rgba(255,255,255,0.1)`, backgroundColor:"rgba(255,255,255,0.04)" }} />

//     <Container maxWidth="xl" sx={{ position: "relative" }}>
//       <SectionHeading
//         eyebrow="Our Faculty"
//         title="Meet The Passionate Educators 👩‍🏫"
//         description="Our teachers are mentors, cheerleaders and guides who make every school day an adventure."
//         align="center"
//         dark
//         eyebrowColor={YELLOW}
//         eyebrowBg="rgba(255,211,61,0.18)"
//       />

//       <Grid container spacing={3}>
//         {highlights.map((h, i) => (
//           <Grid item xs={12} sm={6} md={3} key={i}>
//             <Box
//               sx={{
//                 p: 3.5, height: "100%", textAlign: "center",
//                 borderRadius: "18px",
//                 border: `2.5px solid ${COLORS[i]}`,
//                 backgroundColor: "rgba(255,255,255,0.06)",
//                 boxShadow: `5px 5px 0 ${COLORS[i]}`,
//                 transition: "all 0.25s ease",
//                 "&:hover": { transform: "translate(-3px,-3px)", boxShadow: `8px 8px 0 ${COLORS[i]}`, backgroundColor: "rgba(255,255,255,0.1)" },
//               }}
//             >
//               <Box sx={{ fontSize: "3rem", mb: 2, display: "block", animation: `bounce ${2.2 + i * 0.4}s ease-in-out infinite` }}>{ICONS[i]}</Box>
//               <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.2rem", color: COLORS[i], mb: 1.5 }}>{h.title}</Typography>
//               <Typography sx={{ color: "rgba(255,248,240,0.78)", fontWeight: 600, lineHeight: 1.8, fontSize: "0.88rem" }}>{h.description}</Typography>
//             </Box>
//           </Grid>
//         ))}
//       </Grid>

//       {/* Fun fact banner */}
//       <Box sx={{ mt: 6, p: 3, borderRadius: "16px", border: `2.5px solid ${YELLOW}`, backgroundColor: "rgba(255,211,61,0.1)", boxShadow: `5px 5px 0 ${YELLOW}`, display: "flex", alignItems: "center", gap: 3, flexWrap: "wrap" }}>
//         <Typography sx={{ fontSize: "2.5rem" }}>🎓</Typography>
//         <Box>
//           <Typography sx={{ fontFamily: "'Fredoka One', cursive", fontSize: "1.3rem", color: YELLOW }}>Dedicated & Experienced Teachers</Typography>
//           <Typography sx={{ color: "rgba(255,248,240,0.75)", fontWeight: 600, fontSize: "0.9rem" }}>Passionate educators who guide, inspire and celebrate every student's growth with patience and love.</Typography>
//         </Box>
//       </Box>
//     </Container>
//   </AnimatedSection>
// );

// export default FacultySection;


















import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import AnimatedSection from "../common/AnimatedSection";
import SectionHeading from "../common/SectionHeading";

const NAVY = "#1B1F3B";
const CORAL = "#FF6B6B";
const YELLOW = "#FFD93D";
const TEAL = "#06D6A0";
const PURPLE = "#845EF7";
const ORANGE = "#FF9F1C";
const CREAM = "#FFF8F0";

const ICONS = ["👩‍🏫", "📖", "🧠", "🤝"];
const COLORS = [TEAL, CORAL, PURPLE, ORANGE];
const SUBTITLES = ["Mentors", "Guides", "Innovators", "Partners"];

const FacultySection = ({ highlights }) => (
  <AnimatedSection sx={{ backgroundColor: CREAM, py: { xs: 9, md: 12 }, position: "relative", overflow: "hidden" }}>
    {/* Decorative background elements */}
    <Box sx={{ position: "absolute", top: -50, right: -50, width: 200, height: 200, borderRadius: "50%", backgroundColor: TEAL, border: `3px solid ${NAVY}`, opacity: 0.08 }} />
    <Box sx={{ position: "absolute", bottom: -60, left: -60, width: 240, height: 240, borderRadius: "50%", backgroundColor: CORAL, border: `3px solid ${NAVY}`, opacity: 0.08 }} />
    <Box sx={{ position: "absolute", top: "40%", right: "8%", fontSize: "40px", opacity: 0.06, animation: "floatY 4s ease-in-out infinite" }}>🍎</Box>
    <Box sx={{ position: "absolute", bottom: "30%", left: "5%", fontSize: "35px", opacity: 0.06, animation: "floatY 3.5s ease-in-out infinite" }}>📝</Box>

    <Container maxWidth="xl" sx={{ position: "relative" }}>
      <SectionHeading
        eyebrow="Our Faculty"
        title="Meet Our Dedicated Teachers 👩‍🏫"
        description="Our teachers guide, support and encourage students every day, helping them learn well and grow with confidence."
        align="center"
        eyebrowColor={CORAL}
        eyebrowBg="#FFE8E8"
      />

      <Grid container spacing={3}>
        {highlights.map((h, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Box
              sx={{
                p: 3.5,
                height: "100%",
                textAlign: "center",
                borderRadius: "18px",
                border: `2.5px solid ${NAVY}`,
                backgroundColor: "#fff",
                boxShadow: `5px 5px 0 ${COLORS[i]}`,
                transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                position: "relative",
                overflow: "hidden",
                "&:hover": {
                  transform: "translate(-3px,-3px)",
                  boxShadow: `8px 8px 0 ${COLORS[i]}`,
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  height: "4px",
                  backgroundColor: COLORS[i],
                  borderRadius: "4px 4px 0 0",
                }
              }}
            >
              {/* Icon container */}
              <Box sx={{
                width: 72,
                height: 72,
                mx: "auto",
                mb: 2.5,
                borderRadius: "50%",
                backgroundColor: `${COLORS[i]}15`,
                border: `2.5px solid ${COLORS[i]}`,
                display: "grid",
                placeItems: "center",
                boxShadow: `3px 3px 0 ${COLORS[i]}`,
                animation: `wiggle ${2.5 + i * 0.4}s ease-in-out infinite`,
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "scale(1.1)",
                  boxShadow: `5px 5px 0 ${COLORS[i]}`,
                }
              }}>
                <Typography sx={{ fontSize: "2.5rem", lineHeight: 1 }}>
                  {ICONS[i]}
                </Typography>
              </Box>

              {/* Subtitle badge */}
              <Typography sx={{
                fontFamily: "'Space Grotesk', sans-serif",
                fontSize: "0.7rem",
                fontWeight: 800,
                color: COLORS[i],
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                mb: 1,
                backgroundColor: `${COLORS[i]}12`,
                display: "inline-block",
                px: 1.5,
                py: 0.3,
                borderRadius: "6px",
                border: `1.5px solid ${COLORS[i]}30`,
              }}>
                {SUBTITLES[i]}
              </Typography>

              {/* Title */}
              <Typography sx={{
                fontFamily: "'Fredoka One', cursive",
                fontSize: "1.15rem",
                color: NAVY,
                mb: 1.5,
                lineHeight: 1.3,
              }}>
                {h.title}
              </Typography>

              {/* Description */}
              <Typography sx={{
                color: "#4A4E6D",
                fontWeight: 600,
                lineHeight: 1.8,
                fontSize: "0.88rem",
              }}>
                {h.description}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Fun fact banner */}
      <Box sx={{
        mt: 6,
        p: 3.5,
        borderRadius: "16px",
        border: `2.5px solid ${NAVY}`,
        backgroundColor: "#fff",
        boxShadow: `5px 5px 0 ${YELLOW}`,
        display: "flex",
        alignItems: "center",
        gap: 3,
        flexWrap: "wrap",
        position: "relative",
        overflow: "hidden",
        transition: "all 0.25s ease",
        "&:hover": {
          transform: "translate(-2px,-2px)",
          boxShadow: `7px 7px 0 ${YELLOW}`,
        }
      }}>
        {/* Background pattern */}
        <Box sx={{ position: "absolute", right: -20, top: -20, fontSize: "80px", opacity: 0.06 }}>📚</Box>
        <Box sx={{ position: "absolute", right: 60, bottom: -20, fontSize: "60px", opacity: 0.06 }}>⭐</Box>

        {/* Icon */}
        <Box sx={{
          width: 64,
          height: 64,
          flexShrink: 0,
          borderRadius: "50%",
          backgroundColor: `${YELLOW}20`,
          border: `2.5px solid ${YELLOW}`,
          display: "grid",
          placeItems: "center",
          boxShadow: `3px 3px 0 ${YELLOW}`,
          animation: "wiggle 3s ease-in-out infinite",
        }}>
          <Typography sx={{ fontSize: "2rem" }}>🎓</Typography>
        </Box>

        <Box sx={{ flex: 1, position: "relative" }}>
          <Typography sx={{
            fontFamily: "'Fredoka One', cursive",
            fontSize: "1.3rem",
            color: NAVY,
            mb: 0.5,
          }}>
            Dedicated & Caring Teachers
          </Typography>
          <Typography sx={{
            color: "#4A4E6D",
            fontWeight: 600,
            fontSize: "0.9rem",
            lineHeight: 1.7,
          }}>
            Our teachers support students with care and patience, helping them learn better, build confidence and enjoy their school journey.
          </Typography>
        </Box>
      </Box>
    </Container>
  </AnimatedSection>
);

export default FacultySection;